$('#applicationForm').on('submit-success', function(event, data) {
    // do something with the response data
    console.log(data);
    alert('Pomyślnie przesłano formularz.', 'success');
});